"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _ignoreEvent = _interopRequireDefault(require("../utils/ignoreEvent.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PickerPanelContent(_ref) {
  var activePickerPanel = _ref.activePickerPanel,
    className = _ref.className,
    hideAllPanels = _ref.hideAllPanels,
    i18n = _ref.i18n,
    state = _ref.state,
    uppy = _ref.uppy;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-DashboardContent-panel', className),
    role: "tabpanel",
    "data-uppy-panelType": "PickerPanel",
    id: "uppy-DashboardContent-panel--".concat(activePickerPanel.id),
    onDragOver: _ignoreEvent.default,
    onDragLeave: _ignoreEvent.default,
    onDrop: _ignoreEvent.default,
    onPaste: _ignoreEvent.default
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-bar"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, i18n('importFrom', {
    name: activePickerPanel.name
  })), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: hideAllPanels
  }, i18n('cancel'))), (0, _preact.h)("div", {
    className: "uppy-DashboardContent-panelBody"
  }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
var _default = exports.default = PickerPanelContent;